export const errorMessages = {
  creditVerification: {
    adminError:
      "This loan has been denied and an adverse action letter will be sent.",
  },
};
